module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lKwzo"))).then(() => parcelRequire('1iHdE'));